<template>
  <div id="divSummary">
    <div class="Flex_Table tblEntryForm" style="margin: 10px">
      <div class="Flex_Row">
        <div class="Flex_Cell_Inline">
          <span
            :class="selectTab1 ? 'tabSelectClass' : 'tabClass'"
            v-on:click="tabClick(1)"
            >Create User</span
          >
        </div>
        <div class="Flex_Cell_Inline">
          <span
            :class="selectTab2 ? 'tabSelectClass' : 'tabClass'"
            v-on:click="tabClick(2)"
            >User Authentication</span
          >
        </div>
        <div class="Flex_Cell_Inline">
          <span
            :class="selectTab3 ? 'tabSelectClass' : 'tabClass'"
            v-on:click="tabClick(3)"
            >User Rights</span
          >
        </div>
      </div>
    </div>
    <div style="margin: 10px">
      <div class="Flex_Table" v-if="selectTab1" v-show="selectTab1">
        <create-User></create-User>
      </div>
      <div class="Flex_Table" v-if="selectTab2" v-show="selectTab2">
        <authenticate-User></authenticate-User>
      </div>
      <div class="Flex_Table" v-if="selectTab3" v-show="selectTab3">
        <user-form-Rights></user-form-Rights>
      </div>
    </div>
  </div>
</template>
<script>
import vue from "vue";
import UserAndFormRights from "./UserAndFormRights.vue";
import CreateUser from "./CreateUser.vue";
import AuthenticateUser from "./AuthenticateUser.vue";
import AcceptInput from "./ekkControls/AcceptInput";
import DateControl from "./ekkControls/DateControl";

export default {
  name: "UserManagement",
  components: {
    DateControl: DateControl,
    AcceptInput: AcceptInput,
    "user-form-Rights": UserAndFormRights,
    "create-User": CreateUser,
    "authenticate-User": AuthenticateUser,
  },
  data() {
    return {
      selectTab1: true,
      selectTab2: false,
      selectTab3: false,
    };
  },
  methods: {
    tabClick(type) {
      this.selectTab1 = false;
      this.selectTab2 = false;
      this.selectTab3 = false;
      this.whichTabSelected = type;
      if (type == 1) {
        this.selectTab1 = true;
      } else if (type == 2) {
        this.selectTab2 = true;
      } else {
        this.selectTab3 = true;
      }
    },
  },
  mounted() {},
};
</script>
<style scoped>
.wrapText {
  overflow-wrap: anywhere;
}
#background {
  background: url("../assets/images/logoa.png");
}
.myhead::-webkit-scrollbar {
  background-color: transparent;
}
.myhead::scrollbar {
  background-color: transparent;
}
.mandatorySpan {
  text-align: left;
  position: relative;
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
}
.mandatorySpan.Required:after {
  color: red;
  content: "*";
  position: absolute;
  height: 8px;
  top: -5px;
  font-size: 200%;
}
#divSummary {
  margin-left: 4px;
  margin-right: 5px;
  /* border: dotted 1px darkgray;
        border-radius: 5px;
        padding: 5px 0px 0px 5px; */
}
.ekkGrid > .Flex_Row:hover:not(.GridHeader),
.ekkGrid > .GridContent > .Flex_Row:hover:not(.GridHeader) {
  background-color: #ffa50069;
  color: black;
}
</style>
<style scoped>
.fade-enter-active {
  animation: fade-in 0.4s;
}
.fade-leave-active {
  animation: fade-in 0.4s reverse;
}
@keyframes fade-in {
  0% {
    opacity: 0;
  }
  5% {
    opacity: 0.05;
  }
  10% {
    opacity: 0.1;
  }
  20% {
    opacity: 0.2;
  }
  25% {
    opacity: 0.25;
  }
  30% {
    opacity: 0.3;
  }
  35% {
    opacity: 0.35;
  }
  40% {
    opacity: 0.4;
  }
  45% {
    opacity: 0.45;
  }
  50% {
    opacity: 0.5;
  }
  55% {
    opacity: 0.55;
  }
  60% {
    opacity: 0.6;
  }
  65% {
    opacity: 0.65;
  }
  70% {
    opacity: 0.7;
  }
  75% {
    opacity: 0.75;
  }
  80% {
    opacity: 0.8;
  }
  85% {
    opacity: 0.85;
  }
  90% {
    opacity: 0.9;
  }
  95% {
    opacity: 0.95;
  }
  100% {
    opacity: 1;
  }
}
</style>
<style scoped>
.backgroundPopup {
  position: fixed;
  _position: absolute; /* hack for internet explorer 6*/
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  background: #000000;
  border: 1px solid #cecece;
  z-index: 1;
  opacity: 0.5;
}
.PopUpCover {
  border: solid 1px;
  border-radius: 4px;
  top: 110px;
  position: absolute;
  min-height: 256px;
  right: 380px;
  /* background-color: ;rgba(255, 248, 248, 0.86); */
  background-color: ghostwhite;
  -webkit-box-shadow: 1px 1px 20px 1px white;
  box-shadow: 1px 1px 20px 1px white;
  border-radius: 8px 8px 8px 8px;
  z-index: 2;
  color: black !important;
  width: 600px;
}
.PopUpDetail {
  padding: 10px;
  /* min-height: 200px;
        max-height: 400px; */
  overflow: auto;
}
.PopUpHeader {
  padding: 5px !important;
  font-size: 13pt;
  min-height: 38px;
  border-bottom: solid 1px;
  border-radius: 8px;
}
.PopClose {
  line-height: 18px;
  right: 2px;
  top: 3px;
  position: absolute;
  color: white;
  font-weight: 700;
  display: block;
  padding: 5px;
  background-color: rgba(255, 0, 0, 0.94);
  border-radius: 6px;
  cursor: pointer;
  width: 28px;
  text-align: center;
}
.popbounce-enter-active {
  animation: popbounce-in 0.5s;
}
.popbounce-leave-active {
  animation: popbounce-in 0.4s reverse;
}
.tabClass {
  padding: 5px 8px;
  margin-right: 3px;
  font-size: medium;
  border: solid 1px black;
  border-radius: 6px 6px 0px 0px;
  text-align: center;
  font-family: consolas;
  cursor: pointer;
  border-right: solid 2px black;
  /* box-shadow: 3px 1px 4px; */
  background-color: white;
  color: Black;
}
.tabSelectClass {
  padding: 5px 8px;
  margin-right: 3px;

  background-color: rgb(1, 164, 246) !important;
  font-weight: bold;
  font-family: consolas;
  font-size: medium;
  border: solid 1px black;
  border-right: solid 2px black;
  border-radius: 6px 6px 0px 0px;
  text-align: center;
  border-right: solid 2px black;
  /* box-shadow: 3px 1px 4px black; */
  border-bottom: solid 2px black;
  cursor: pointer;
  color: white;
}
@keyframes popbounce-in {
  0% {
    transform: scale(0);
  }
  25% {
    transform: scale(0.25);
  }
  50% {
    transform: scale(0.5);
  }
  75% {
    transform: scale(0.75);
  }
  100% {
    transform: scale(1);
  }
}
</style>
<style scoped>
@media screen and (max-width: 800px) {
  .EntryBlock {
    width: 80%;
  }
  #divApplication {
    display: block;
    height: auto;
  }
  #location {
    width: 70%;
  }
  .PopUpCover {
    right: 0px !important;
    left: 18px !important;
  }
  .EntryBlock {
    width: 100%;
  }
  fieldset > div {
    width: calc(100vw - 15px);
    overflow: auto;
  }
  .tblEntryForm {
    width: calc(100vw - 35px);
  } /* width 15px less*/
  .tblEntryForm .Flex_Row {
    display: flex;
    flex-wrap: wrap;
  } /* this is responsible for cell wraping*/
  .tblEntryForm .Flex_Row > .Flex_Cell {
    width: 50% !important;
  } /* width of any cell time of screen sizing*/
  .tblEntryForm .Flex_Row > .Flex_Cell_Inline {
    width: 50% !important;
    line-height: 36px;
  } /* width of any cell time of screen sizing*/
  /* Auto calculate the height of the grid div for scrolling when screen size change*/
  .Location {
    max-width: calc(100vw - 30px) !important;
    width: calc(100vw - 40px) !important;
  }
  /*Overflow for horizontal */
  .ekkGrid .GridContent {
    overflow: unset;
  }
  /*then only horizontal scrolling works */
  .Flex_Table.ekkGrid .Flex_Row {
    width: 100%;
  }
}
@media screen and (max-width: 480px) {
  .EntryBlock {
    width: calc(100vw - 35px);
  }
  fieldset > div {
    width: calc(100vw - 35px);
    overflow: auto;
  }
  #location {
    width: 70%;
  }
  .PopUpCover {
    right: 0px !important;
    left: 18px !important;
  }
  .tblEntryForm > .Flex_Row > .Flex_Cell {
    width: 100% !important;
  }
  .tblEntryForm > .Flex_Row > .Flex_Cell_Inline {
    width: 100% !important;
    line-height: 36px;
  }
  .tblEntryForm .divHR {
    display: block;
  }
  .Flex_Table.ekkGrid.Location {
    max-width: calc(100vw - 40px) !important;
    width: calc(100vw - 40px) !important;
  }
  legend {
    width: calc(100vw - 40px) !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/UserManagement.vue